import { createSlice } from '@reduxjs/toolkit';
import AppSettingsService from '../../services/appSettings';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  settings: null
};

const slice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getSettingsSuccess(state, action) {
      state.isLoading = false;
      state.settings = action.payload || null;
    }
  }
});

export default slice.reducer;
export const { startLoading, hasError, getSettingsSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getAppSettings() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const response = await AppSettingsService.get();
    if (response.success) {
      dispatch(slice.actions.getSettingsSuccess(response.data));
    } else {
      dispatch(slice.actions.hasError(response.errors || 'Failed to fetch settings'));
    }
    return response;
  };
}

export function updateAppSettings(payload) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const response = await AppSettingsService.update(payload);
    if (response.success) {
      dispatch(slice.actions.getSettingsSuccess(response.data));
    } else {
      dispatch(slice.actions.hasError(response.errors || response.message || 'Failed to update settings'));
    }
    return response;
  };
}
